export default __webpack_public_path__ + "857582adec4fdaa457d39f270a5e21c1.png";